import React from "react";
import classNames from "classnames";
import { userColor, userFullName, userInitials } from "../../utils/userUtils";
import { Trans as T } from 'react-i18next';

import Dropdown from 'react-bootstrap/Dropdown';
import ChevronIcon from "../../assets/icons/ChevronIcon";

import './LeadDropdown.scss';

export default function LeadAssigneeDropdown({ users, selectedUserId, onChange, lead, type, hideUnassigned, placeholder, fixed, allowUnassigned }) {
  if (!users) {
    return <div>...</div>;
  }

  const selectedUser = users?.find(user => user.id === selectedUserId || user.id === lead?.assigned_user_id);
  const unassignedSelected = allowUnassigned ? selectedUserId === -1 : !selectedUser;

  return (
    <Dropdown className={classNames('__lead-dropdown', { [`__lead-dropdown-${type}`]: type })}>
      <Dropdown.Toggle as={Toggle} className='lead-toggle' type="button">
        <div className="toggle-overflow">
          { selectedUser && <div className='user-color' style={{ backgroundColor: selectedUser ? userColor(selectedUser).code : 'transparent' }}>{ userInitials(selectedUser) }</div> }
          <div className={classNames('label', { unassigned: unassignedSelected })}>{ userFullName(selectedUser) || (unassignedSelected ? <T>Unassigned</T> : placeholder) || <T>Unassigned</T> }</div>
          <ChevronIcon className='chevron' />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount={fixed} popperConfig={fixed && { strategy: 'fixed' }}>
        { users.length === 0 && (
          <Dropdown.ItemText className="empty-text">(No users found)</Dropdown.ItemText>
        )}
        { users.map(user => (
          <Dropdown.Item key={user.id} as='button' type="button" active={selectedUser?.id === user.id } onClick={() => onChange(user.id)}>
            <div className='user-color' style={{ backgroundColor: userColor(user).code }}>{ userInitials(user) }</div>
            <div className='label'>{ userFullName(user) }</div>
          </Dropdown.Item>
        ))}
        {!hideUnassigned && (
          <Dropdown.Item as='button' onClick={() => onChange(allowUnassigned ? -1 : null)} active={unassignedSelected}>
            <div className='user-color' /><div className='label'><T>Unassigned</T></div>
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const Toggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props}>
    { children }
  </button>
));
